<template>
  <modal
    class="createAssetGroup"
    name="linkBankAccount"
    :clickToClose="false"
    transition="pop-out"
    :width="1000"
    :height="560"
    @closed="closed"
    @opened="opened"
  >
    <div class="assets_modal_div w-100">
      <div class="ml-3" v-if="mode == 'nonLinked'">
        <button @click="changeMode(null)" class="back-btn">
          <i
            class="mr-2 fa fa-long-arrow-left back-arrow"
            aria-hidden="true"
          ></i>
          <div>{{ $t("text.linkBankAccModal.back") }}</div>
        </button>
      </div>
      <img
        src="@/assets/img/cancel-button.svg"
        class="close_assets_modal"
        @click="closeModal"
      />
      <div class="mt-2 w-100">
        <div class="row">
          <div
            class="text-center col-md-6 right-border"
            :style="[mode == 'nonLinked' ? { opacity: '0.2' } : null]"
          >
            <div class="text-center col-center-flex">
              <div class="mt-5 square-icon-wrapper large fill">
                <img src="@/assets/img/av.svg" width="80" />
              </div>
            </div>
            <h5 class="mt-4 primary-color">
              <span>{{ $t("text.linkBankAccModal.linkedAccounts") }}</span>
              <span class="ml-3 badge success">
                <small> {{ $t("text.linkBankAccModal.recommended") }} </small>
              </span>
            </h5>
            <div class="mt-4 text-center modal-para">
              {{ $t("text.linkBankAccModal.desc") }}, <br />
              {{ $t("text.linkBankAccModal.desc1") }}
            </div>
            <div class="mt-4">
              <button
                @click="launchMono()"
                class="ep-btn ep-primary"
                :disabled="isButtonDisabled ? true : null"
                :style="[
                  isButtonDisabled
                    ? { cursor: 'not-allowed' }
                    : { cursor: 'pointer' },
                ]"
              >
                {{ $t("text.linkBankAccModal.proceed") }}
                <img
                  src="@/assets/img/git_loader.gif"
                  style="display: none"
                  width="20px"
                  class="ml-3 loader"
                />
              </button>
            </div>
          </div>
          <div class="col-md-6">
            <div v-if="mode !== 'nonLinked'">
              <div class="text-center col-center-flex">
                <div class="mt-5 square-icon-wrapper large transparent">
                  <img src="@/assets/img/bank (1).svg" width="80" />
                </div>
              </div>
              <h5 class="mt-4 text-center primary-color header-label">
                {{ $t("text.linkBankAccModal.nonlinkedAccounts") }}
              </h5>
              <div class="mt-4 text-center modal-para">
                {{ $t("text.linkBankAccModal.regAccount") }}
              </div>
              <div class="mt-5 text-center">
                <button class="ep-btn ep-secondary" @click="addBank">
                  {{ $t("text.linkBankAccModal.addNewBank") }}
                </button>
              </div>
            </div>
            <div v-if="mode === 'nonLinked'" class="add-bank-form">
              <h6 class="primary-color">
                <img src="@/assets/img/bank (1).svg" width="25" class="mr-4" />
                <span>{{ $t("text.linkBankAccModal.nonlinkedAccounts") }}</span>
              </h6>
              <div class="mt-3 modal-para">
                {{ $t("text.linkBankAccModal.nonLinkedDesc") }}
              </div>
              <form class="mt-4">
                <label class="text-left"
                  >{{ $t("text.linkBankAccModal.accountName") }}
                </label>
                <div>
                  <input
                    type="text"
                    :placeholder="$t('text.linkBankAccModal.enterfullname')"
                    v-model="accountName"
                    class="w-100"
                  />
                </div>
                <div class="mt-3">
                  <label
                    >{{ $t("text.linkBankAccModal.accountNumber") }}
                  </label>
                  <input
                    type="text"
                    :placeholder="$t('text.linkBankAccModal.accountNumber')"
                    v-model="accountNumber"
                    class="w-100"
                  />
                </div>
                <div class="pb-3 mt-3">
                  <label>{{ $t("text.linkBankAccModal.bank") }}</label>
                  <details class="mb-4 input__block position-relative">
                    <summary class="p-3 dropdown-info">
                      {{ selectedBank.bankName }}
                    </summary>
                    <div class="summary-content" style="height: 300px">
                      <div class="empty-info-wrapper new-row" v-if="!bankNames">
                        <img
                          src="@/assets/img/bank-building (2) (2).svg"
                          width="50"
                        />
                        <p class="mt-5 light-grey-text">
                          {{ $t("text.linkBankAccModal.compNoBankAcc") }}
                        </p>
                        <small class="light-grey-text">{{
                          $t("text.linkBankAccModal.accWillBeDisplayed")
                        }}</small>
                      </div>
                      <ul>
                        <li
                          v-for="(bank, i) in bankNames"
                          :key="i"
                          class="cursor-pointer primary-color"
                          @click="selectBank(bank)"
                        >
                          <img :src="bank.iconUrl" width="40" />
                          <span class="">
                            {{ bank.bankName }}
                          </span>
                        </li>
                      </ul>
                      <div v-if="!bankNames.length" class="text-center py-5 m-">
                        {{ $t("text.linkBankAccModal.noBankrecords") }}
                      </div>
                    </div>
                  </details>
                  <!-- <select v-model="bankName">                      
                                    <option value="select bank" disabled selected hidden>select bank</option>
                                    <option v-for="(bank, index) in bankNames" 
                                        :key="index" 
                                        v-bind:value="bank.bankName">{{bank.bankName}}
                                    </option>                      
                                </select> -->
                </div>

                <div class="mt-3 text-center">
                  <button
                    class="ep-btn ep-primary"
                    @click="addBankAccts($event)"
                    :disabled="isButton_2_Disabled ? true : null"
                    :style="[
                      isButton_2_Disabled
                        ? { cursor: 'not-allowed' }
                        : { cursor: 'pointer' },
                    ]"
                  >
                    {{ $t("text.linkBankAccModal.addNewBank") }}
                    <img
                      src="@/assets/img/git_loader.gif"
                      style="display: none"
                      width="20px"
                      class="ml-3 loader1"
                    />
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </modal>
</template>
<script>
const MODAL_WIDTH = 1080;
import configObject from "@/config";
import JQuery from "jquery";
let $ = JQuery;

export default {
  name: "linkBankAccount",
  props: ["companyId"],
  data() {
    return {
      // company: localStorage.getItem("companyDetails")
      //         ? JSON.parse(localStorage.getItem("companyDetails"))
      //         : null,
      modalWidth: MODAL_WIDTH,
      name: "",
      description: "",
      groupType: "selectGroupType",
      isButtonDisabled: false,
      showLoader: false,
      branch: {},
      branchId: null,
      mode: null,
      amount: 0,
      bankNames: [],
      accountName: "",
      accountNumber: "",
      bankName: "select bank",
      isButton_2_Disabled: false,
      selectedBank: { bankName: "select bank" },
    };
  },
  computed: {
    company() {
      return this.$store.getters.getCompanyDetails;
    },
  },
  mounted() {},
  created() {
    this.$eventHub.$on("branch", (branch) => {
      this.branch = branch;
      document.title = `Link Bank Accounts :: ${branch.name} Retail Outlet`;
    });
    this.modalWidth =
      window.innerWidth < MODAL_WIDTH ? MODAL_WIDTH / 2 : MODAL_WIDTH;
  },
  watch: {
    mode(mode) {
      if (mode == "nonLinked") {
        this.isButtonDisabled = true;
      }
      if (mode == null) {
        this.isButtonDisabled = false;
      }
    },
  },
  methods: {
    closed() {
      this.selectedBank = {};
      this.mode = null;
    },
    opened() {
      this.getBankList();
    },
    closeModal() {
      this.$modal.hide("linkBankAccount");
    },
    changeMode(mode) {
      this.mode = mode;
    },
    launchMono() {
      const options = {
        onSuccess: (response) => {
          this.code = response.code;
          this.linkBankAccount();
        },
        onClose: function () {},
      };
      this.$launchMono(options);
    },
    selectBank(bank) {
      this.selectedBank = bank;
      Array.from(document.querySelectorAll("details")).forEach((detail) => {
        detail.open = false;
      });
    },
    addBank(e) {
      e.preventDefault();
      this.mode = "nonLinked";
    },
    addBankAccts($event) {
      $event.preventDefault();
      if (!this.bankName) {
        this.$toast.open({
          message: this.$t("text.bankAccounts.selectBankError"),
          type: "error",
          duration: 5000,
        });
        return;
      }
      if (!this.accountNumber) {
        this.$toast.open({
          message: this.$t("text.errors.accountNumberMissing"),
          type: "error",
          duration: 5000,
        });
        return;
      } else {
        if (this.accountNumber.length !== 10) {
          this.$toast.open({
            message: this.$t("text.linkBankAccModal.accNoErr"),
            type: "error",
            duration: 5000,
          });
          return;
        }
      }
      if (!this.accountName) {
        this.$toast.open({
          message: this.$t("text.errors.accountNameMissing"),
          type: "error",
          duration: 5000,
        });
        return;
      }

      let data = {
        bankName: this.selectedBank.bankName,
        accountNumber: this.accountNumber,
        accountName: this.accountName,
        bankCode: "",
        companyId: this.companyId
      };
      

      this.isButton_2_Disabled = true;
      $(".loader1").show();
      this.axios
        .post(
          `${configObject.apiBaseUrl}/Company/AddBankAccount`,
          data,
          configObject.authConfig()
        )
        .then(() => {
          this.isButton_2_Disabled = false;
          $(".loader1").hide();
          this.$toast.open({
            message: this.$t("text.bankAccounts.bankAdded"),
            type: "success",
            duration: 5000,
          });
          this.accountNumber = "";
          this.accountName = "";
          this.closeModal();
          this.$eventHub.$emit("refreshLinkedBankAccount");
        })
        .catch((error) => {
          this.$toast.open({
            message: error.response.data.message,
            type: "error",
            duration: 5000,
          });
          this.isButton_2_Disabled = false;
          $(".loader1").hide();
        });
    },
    // getBanks() {
    //   this.axios
    //     .get(
    //       `${configObject.apiBaseUrl}/Branch/Banks`,
    //       configObject.authConfig()
    //     )
    //     .then(response => {
    //       this.bankNames = response.data.data;
    //     })
    //     .catch(error => {

    //     });
    // },
    getBankList() {
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Utilities/BankList?ApplyPaging=false&companyId=${this.companyId}`,
          configObject.authConfig()
        )
        .then((response) => {
          this.bankNames = response.data.data;
        })
        .catch((error) => {});
    },
    linkBankAccount() {
      let data = {
        companyId: this.companyId,
        code: this.code,
      };
      this.isButtonDisabled = true;
      $(".loader").show();

      this.axios
        .post(
          `${configObject.apiBaseUrl}/Company/AddLinkedBankAccount`,
          data,
          configObject.authConfig()
        )
        .then((res) => {
          this.isButtonDisabled = false;
          $(".loader").show();
          this.$toast.open({
            message: this.$t("text.linkBankAccModal.linkAccSuccess"),
            type: "success",
            duration: 3000,
          });
          this.closeModal();
          this.$eventHub.$emit("refreshLinkedBankAccount");
        })
        .catch((error) => {
          this.isButtonDisabled = false;
          $(".loader").show();
          this.$toast.open({
            message: error.response.data.message,
            type: "error",
            duration: 3000,
          });
        });
    },
  },
};
</script>
